import requests from './requests';

export default {
    grant(code) {
        return requests
            .get('/coach/wechat/grant', {
                params: {
                    code,
                },
            })
            .then(resp => resp.data);
    },
    jssdk(url) {
        return requests
            .post('/coach/wechat/jssdk', {
                url,
            })
            .then(resp => resp.data);
    },
    getUser(openid) {
        return requests
            .get(`/coach/wechat/user/${openid}`)
            .then(resp => resp.data);
    },
};



// WEBPACK FOOTER //
// ./src/api/wechat.js